import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import isBetween from 'dayjs/plugin/isBetween'
import relativeTime from 'dayjs/plugin/relativeTime';
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import locale from 'ant-design-vue/es/date-picker/locale/es_ES';
dayjs.extend(updateLocale);
dayjs.extend(isBetween);
dayjs.extend(relativeTime);
dayjs.updateLocale('es-mx');
dayjs.extend(utc);
dayjs.extend(timezone);
const calculateDiff = (fecha) => {
    if (fecha !== undefined && fecha !== false && dayjs(fecha).isValid()) {
        const today = dayjs()
        const fechaPasada = dayjs(fecha)
        const diffHours = today.diff(fechaPasada, 'hours')
        const diffDays = today.diff(fechaPasada, 'days');
        if (diffHours < 24) {
            return "hace " + diffHours + " horas"
        } else {
            return "hace " + diffDays + " días"
        }
    } else {
        return "En Espera"
    }
    
}
const esLocale = () => {
    locale.lang.shortMonths = [
            'Ene',
            'Feb',
            'Mar',
            'Abr',
            'May',
            'Jun',
            'Jul',
            'Ago',
            'Sep',
            'Oct',
            'Nov',
            'Dic',
    ]
    locale.lang.weekdays = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
    locale.lang.shortWeekDays = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb']
    return locale
}
const formatDate = (dateString, format = 'DD/MM/YYYY', timezone = 'America/Caracas') => {
  let myday = null  
  if (dateString == '') {
    myday = dayjs();
  } else {
    myday = dayjs(dateString);
  }
  return myday.format(format)
    
}
export { dayjs, calculateDiff, esLocale, formatDate }